import React from 'react';

export const Skeleton = () => (
  <div className="my-5 space-y-3">
    <div className="flex items-center justify-between px-4">
      <div className="h-6 w-32 animate-pulse rounded bg-gray-200" />
      <div className="h-6 w-20 animate-pulse rounded bg-gray-200" />
    </div>
    {Array.from({ length: 3 }).map(() => (
      // eslint-disable-next-line react/jsx-key
      <div className="shadow-xs space-y-3 rounded-xl bg-white px-4 py-3">
        <div className="px-1">
          <div className="h-6 w-3/4 animate-pulse rounded bg-gray-200" />
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
          {Array.from({ length: 4 }).map(() => (
            // eslint-disable-next-line react/jsx-key
            <div className="h-13 w-full animate-pulse rounded-xl bg-gray-200" />
          ))}
        </div>
      </div>
    ))}
  </div>
);
